<template>
  <v-footer id="dashboard-core-footer" fixed absolute height="30" padless>
    <v-container>
      <v-row align="center">
        <v-col
          v-for="(link, i) in links"
          :key="i"
          class="text-center"
          cols="auto"
        >
          <v-btn
            text
            color="error"
            :href="link.href"
            class="grey--text text--darken-3"
            rel="noopener"
            target="_blank"
            v-text="link.text"
          >
          </v-btn>
        </v-col>

        <v-spacer class="hidden-sm-and-down" />

        <v-col cols="12" md="auto">
          <div class="font-weight-bold text-center">
           {{ $appVersion.version }} &copy; 2021 กลุ่มงานจัดการบุคคล, made with
            <v-icon size="18" color="red">
              mdi-heart
            </v-icon>
            by <a href="https://ovec.go.th/">Team DIGITAL VEC</a>
          </div>
        </v-col>
      </v-row>
    </v-container>

     <v-dialog v-model="showDialog" max-width="450">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-information</v-icon>
          ข้อมูลเวอร์ชันระบบ
        </v-card-title>
        
        <v-card-text class="pt-4">
          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-numeric</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>เวอร์ชัน</v-list-item-subtitle>
                <v-list-item-title class="text-h6 primary--text">
                  {{ $appVersion.version }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider class="my-2"></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-calendar</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>วันที่สร้าง</v-list-item-subtitle>
                <v-list-item-title>
                  {{ formattedBuildDate }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider class="my-2"></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-pound</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>Build Number</v-list-item-subtitle>
                <v-list-item-title>
                  {{ $appVersion.buildNumber || 'N/A' }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-divider class="my-2"></v-divider>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-web</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-subtitle>สภาพแวดล้อม</v-list-item-subtitle>
                <v-list-item-title>
                  {{ environment }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-alert
            v-if="$appVersion.error"
            type="warning"
            dense
            text
            class="mt-3 mb-0"
          >
            <small>{{ $appVersion.error }}</small>
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="showDialog = false"
          >
            <v-icon left>mdi-close</v-icon>
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-footer>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "DashboardCoreFooter",

  data() {
    return {
      showDialog: false,
      version: "Loading...",
      buildDate: null,
      links: [
        {
          href: "https://ipa.vec.go.th/",
          text: "กลุ่มงานจัดการบุคคล",
          icon: "mdi-account-multiple"
        },
        {
          href: "https://boga.vec.go.th/",
          text: "สำนักอำนวยการ"
        }
      ]
    };
  },

  computed: {
    currentYear() {
      return new Date().getFullYear() + 543; // แปลงเป็น พ.ศ.
    },

    formattedBuildDate() {
      if (!this.$appVersion.buildDate) return "ไม่มีข้อมูล";

      try {
        const date = new Date(this.$appVersion.buildDate);
        return date.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        });
      } catch (error) {
        return "ไม่สามารถแสดงได้";
      }
    },

    environment() {
      return process.env.NODE_ENV === "production"
        ? "Production"
        : "Development";
    }
  },

  mounted() {
    console.log("Footer mounted with version:", this.$appVersion);
  }
};
</script>

<style lang="sass">
#dashboard-core-footer
  a
    font-size: .825rem
    font-weight: 500
    text-decoration: none
    text-transform: uppercase
</style>
